'use client';

import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { RootState } from '@/_lib/client/redux/store';
import { clearError } from '@/_lib/client/redux/slices/authSlice';

export function AuthErrorToast() {
  const error = useSelector((state: RootState) => state.auth.errorMessage);
  const status = useSelector((state: RootState) => state.auth.status);
  const dispatch = useDispatch();

  useEffect(() => {
    if (status === 'error' && error) {
      toast.error(error);

      // Clear the error after toast shows
      const timeout = setTimeout(() => {
        dispatch(clearError());
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [error, status, dispatch]);

  return null;
}
